export const removeUnderscore = (str) => str.replace(/_/g, " ");
